import { takeLatest } from "redux-saga/effects";
import actions from "../constants/hubReconciliationActions";
import {
  getHubReconciliationList,
  startHubReconciliation,
  scanBarcode,
  closeHubReconciliation,
  getReportData,
} from "../workers/hubReconciliationWorker";

export function* getHubReconciliationListWatcher() {
  yield takeLatest(actions.GET_HUB_RECONCILIATION_LIST, getHubReconciliationList);
}

export function* startHubReconciliationWatcher() {
  yield takeLatest(actions.START_HUB_RECONCILIATION, startHubReconciliation);
}

export function* scanBarcodeWatcher() {
  yield takeLatest(actions.SCAN_BARCODE, scanBarcode);
}

export function* closeHubReconciliationWatcher() {
  yield takeLatest(actions.CLOSE_HUB_RECONCILIATION, closeHubReconciliation);
}

export function* getReportDataWatcher() {
  yield takeLatest(actions.GET_REPORT_DATA, getReportData);
}
